import {
  agentChatTakenByAuditorAudio,
  agentChatTransferApproveAudio,
  agentChatTransferCancelAudio,
  agentChatTransferRejectAudio,
  agentChatTransferRequestAudio,
  newInMsgAudio,
} from '@resources';
import React from 'react';

const EventsWithAudio: React.FC = () => (
  <div>
    <audio id="newMsgAudio" src={newInMsgAudio} preload="auto">
      <track kind="captions" />
    </audio>
    <audio
      id="agentChatTransferRequestAudio"
      src={agentChatTransferRequestAudio}
      preload="auto"
    >
      <track kind="captions" />
    </audio>
    <audio
      id="agentChatTransferApproveAudio"
      src={agentChatTransferApproveAudio}
      preload="auto"
    >
      <track kind="captions" />
    </audio>
    <audio
      id="agentChatTransferRejectAudio"
      src={agentChatTransferRejectAudio}
      preload="auto"
    >
      <track kind="captions" />
    </audio>
    <audio
      id="agentChatTransferCancelAudio"
      src={agentChatTransferCancelAudio}
      preload="auto"
    >
      <track kind="captions" />
    </audio>
    <audio
      id="agentChatTakenByAuditorAudio"
      src={agentChatTakenByAuditorAudio}
      preload="auto"
    >
      <track kind="captions" />
    </audio>
  </div>
);

export default EventsWithAudio;
